import { format, parseISO } from "date-fns";
import { es } from "date-fns/locale";
import { Calendar as CalendarIcon } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Calendar } from "../ui/calendar";

// value/onChange usan cadena ISO "YYYY-MM-DD". Coherente con dark mode.
export default function DatePicker({ value, onChange, placeholder = "Selecciona fecha", testid }) {
  const date = value ? parseISO(value) : undefined;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className="field flex items-center gap-2 text-left text-sm data-[empty=true]:text-navy/40"
          data-empty={!value}>
          <CalendarIcon className="w-4 h-4 text-navy/40 shrink-0" />
          {value ? format(date, "d 'de' MMMM, yyyy", { locale: es }) : placeholder}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" selected={date} locale={es}
          onSelect={(d) => onChange(d ? format(d, "yyyy-MM-dd") : "")} initialFocus />
      </PopoverContent>
    </Popover>
  );
}
